module.exports = __webpack_public_path__ + "img/tree-04-c-trunk.64322d07.png";